import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const LightningFilled = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox={`0 0 20 20`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M4.48901 11.2316L10.0782 2.44859C10.3467 2.02657 11 2.2168 11 2.71703V8.9C11 8.95523 11.0448 9 11.1 9H15.0397C15.4442 9 15.6813 9.45534 15.4493 9.78673L9.90962 17.7005C9.62928 18.101 9 17.9027 9 17.4138V12.1C9 12.0448 8.95523 12 8.9 12H4.91084C4.51629 12 4.27718 11.5644 4.48901 11.2316Z"
          fill="white"
          stroke={color}
          strokeWidth="1.5"
        />
      </svg>
    )
  },
)

export default LightningFilled
